enum ImageReviewStates {
  NotStarted = 'Not',
  Review = 'Review',
  Complete = 'Complete',
}

export { ImageReviewStates }
